var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"print-box",style:(_vm.printSize == 'A4' ? 'height: 650px;' : 'height: 490px;'),domProps:{"innerHTML":_vm._s(_vm.printSize == 'A4' ? _vm.data.html : _vm.data)}})])}
var staticRenderFns = []

export { render, staticRenderFns }